import { configureStore } from '@reduxjs/toolkit';
import globalDataReducer from './reducers/globalData';
import userInfoReducer from './reducers/userInfo';
import messageReducer from './reducers/message';

export const store = configureStore({
  reducer: {
    globalData: globalDataReducer,
    userInfo: userInfoReducer,
    message: messageReducer,
  }
})